import {
  LOADING,
  MAP_VISIBLE_TABLES_LOADED,
  MAP_VISIBLE_TABLES_UPDATED,
  MAP_SCALE_UPDATED,
} from '../actions/constants';

const INITIAL_STATE = {
  mapKey: 1, // we change this whenever we want Map to throw away its state
  diagramHasChanged: false, // boolean showing whether map has changes
  visibleTables: null, // list of MapsTable objs. Changes as map changes
  scale: 0.9,
};

const Maps = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING: {
      switch (action.awaiting) {
        default:
          return state;
      }
    }
    case MAP_VISIBLE_TABLES_LOADED: {
      return {
        ...state,
        mapKey: state.mapKey + 1,
        visibleTables: action.payload.visibleTables,
        diagramHasChanged: false,
      };
    }
    case MAP_VISIBLE_TABLES_UPDATED: {
      return {
        ...state,
        mapKey: action.payload.updateMapKey ? state.mapKey + 1 : state.mapKey,
        visibleTables: action.payload.visibleTables,
        diagramHasChanged: true,
      };
    }
    case MAP_SCALE_UPDATED: {
      return {
        ...state,
        mapKey: state.mapKey + 1,
        scale: action.payload.scale,
      };
    }
    default:
      return state;
  }
};

export default Maps;
